import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const SHLAA: Layer = {
  id: ConstraintsCategory.SHLAA,
  layerType: ConstraintsLayerType,
  title: "Land availability assessments",
  toggleable: true,
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  group: LayerGroup.POLICY,
  icon: "lt-layer-shlaa",
  description: "Strategic land housing availability assessment",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.SHLAA,
    categorySchema: [
      { key: "shlaa_positive" },
      { key: "shlaa_neutral" },
      { key: "shlaa_negative" },
      { key: "brownfield_land" },
    ],
  },
};
